import { Link } from "react-router-dom";
import { FCAData } from "@/mocks/fca";
import { estadoFitoConfig, riscoConfig, statusRevisaoConfig } from "@/mocks/cta";
import QRCodeMock from "./QRCodeMock";

interface Props {
  data: FCAData;
}

export default function TreeProfileHeader({ data }: Props) {
  const estadoFito = estadoFitoConfig[data.estadoFitossanitario] || { badge: "bg-background-100 text-foreground-500", label: data.estadoFitossanitario };
  const risco = riscoConfig[data.classeRisco] || { badge: "bg-background-100 text-foreground-500", label: data.classeRisco };
  const statusRev = statusRevisaoConfig[data.statusRevisao] || { badge: "bg-background-100 text-foreground-500", label: data.statusRevisao };

  return (
    <div className="bg-white rounded-card border border-background-200/70 overflow-hidden">
      {/* Top section with photo + info */}
      <div className="flex flex-col lg:flex-row">
        {/* Photo */}
        <div className="lg:w-[340px] shrink-0 h-[260px] lg:h-auto relative bg-background-100">
          <img
            src={data.fotoPrincipal}
            alt={`${data.nomePopular} - ${data.codigoCta}`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
            <span className={`badge ${estadoFito.badge}`}>
              <i className="ri-heart-pulse-line mr-1 text-[10px]"></i>
              {estadoFito.label}
            </span>
            <span className={`badge ${risco.badge}`}>
              <i className="ri-alert-line mr-1 text-[10px]"></i>
              Risco {risco.label}
            </span>
          </div>
        </div>

        {/* Info */}
        <div className="flex-1 p-5 flex flex-col justify-between">
          <div>
            {/* Breadcrumb */}
            <nav className="flex items-center gap-1.5 text-xs text-foreground-500 mb-3 flex-wrap" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-accent-500 transition-colors">Dashboard</Link>
              <i className="ri-arrow-right-s-line text-[10px]" aria-hidden="true"></i>
              <Link to="/cta" className="hover:text-accent-500 transition-colors">CTA Arbóreo</Link>
              <i className="ri-arrow-right-s-line text-[10px]" aria-hidden="true"></i>
              <span className="text-foreground-700 font-medium">FCA</span>
              <i className="ri-arrow-right-s-line text-[10px]" aria-hidden="true"></i>
              <span className="text-accent-600 font-medium truncate">{data.codigoCta}</span>
            </nav>

            {/* Code + name */}
            <div className="flex items-start justify-between gap-4 mb-3">
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-mono text-foreground-500 bg-background-100 px-2 py-0.5 rounded-md">
                    {data.codigoCta}
                  </span>
                  <span className={`badge ${statusRev.badge}`}>{statusRev.label}</span>
                  <span className="badge bg-secondary-100 text-secondary-700">{data.tipo}</span>
                </div>
                <h1 className="text-xl font-bold text-foreground-900 font-heading leading-tight">
                  {data.nomePopular}
                </h1>
                <p className="text-sm text-foreground-500 italic mt-0.5">
                  {data.nomeCientifico}
                </p>
              </div>
              <QRCodeMock />
            </div>
          </div>

          {/* Action buttons */}
          <div className="flex flex-wrap items-center gap-2 mt-3 pt-3 border-t border-background-200/70">
            <button className="btn-primary text-xs whitespace-nowrap">
              <i className="ri-edit-line" aria-hidden="true"></i>
              Editar cadastro
            </button>
            <button className="btn-secondary text-xs whitespace-nowrap">
              <i className="ri-clipboard-line" aria-hidden="true"></i>
              Nova vistoria
            </button>
            <button className="btn-outline text-xs whitespace-nowrap">
              <i className="ri-map-pin-line" aria-hidden="true"></i>
              Abrir no mapa
            </button>
            <button className="btn-outline text-xs whitespace-nowrap">
              <i className="ri-file-pdf-line" aria-hidden="true"></i>
              Gerar PDF
            </button>
            <div className="relative ml-auto">
              <button className="btn-outline text-xs whitespace-nowrap">
                <i className="ri-more-2-fill" aria-hidden="true"></i>
                Mais ações
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}